import React, { Component } from 'react';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: null,
      pass: null,
      remember: false,
      error: null,
      loading: false
    }
  }

  handleChange(e){
    var newState = {};
    newState[e.target.name] = e.target.value;
    this.setState(newState);
  }

  handleCheck(e){
    this.setState({remember: e.target.checked});
  }

  handleSubmit(e){
    e.preventDefault();

    if(this.state.loading)
      return;

    this.setState({error: '', loading: true})

    fetch('/api/login', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({
        email: this.state.email,
        pass: this.state.pass,
        remember: this.state.remember
      }),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => res.ok ? res.json() :
      this.setState({error: 'An error occurred: '+res.statusText, loading: false})
    )
    .then(res => {
      if(res.error)
        this.setState({error: res.error, loading: false})
      else {
        this.setState({loading: false})
        this.props.setUser(res);
        window.location.href = '#/dashboard';
      }
    })
  }

  render() {
    return (
      <div className="">
        <h1>Login</h1>

        { this.state.error ?
          <div className="alert alert-danger">{this.state.error}</div>
         : null }

        <form onSubmit={this.handleSubmit.bind(this)}>
          <input type="email"
            required
            onChange={this.handleChange.bind(this)}
            name="email"
            className="form-control"
            id="exampleInputEmail1"
            placeholder="Email" />
          <br />
          <input type="password"
            required
            onChange={this.handleChange.bind(this)}
            name="pass"
            className="form-control"
            id="exampleInputPassword1"
            placeholder="Password" />
          <div className="checkbox">
            <label>
              <input type="checkbox" onChange={this.handleCheck.bind(this)} /> Keep me logged in
            </label>
          </div>

          <p className="text-center">
            <button
              disabled={this.state.loading}
              className="btn btn-primary">
                { this.state.loading ? 'Loading...' : 'Log in' }
            </button>
          </p>

          <p className="text-center">
            <a href="#/forgot">Forgot Password</a>
          </p>
          <p className="text-center">
            <a href="#/signup">Sign Up</a>
          </p>
        </form>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login.js